// // Image Skeleton
// export const ImageSkeleton = () => (
//   <div
//     className="image-skeleton"
//     style={{
//       aspectRatio: "1/1",
//       background:
//         "linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%)",
//       backgroundSize: "400% 100%",
//       animation: "shimmer 1.5s infinite",
//       maxHeight: "200px",
//     }}
//   />
// );
// Skeleton.jsx
import "./Skeleton.css";
export const ImageSkeleton = ({ className = "" }) => (
  <div className={`image-skeleton ${className}}`} />
);

// Video Skeleton
export const VideoSkeleton = () => (
  <div
    className="video-skeleton"
    style={{
      aspectRatio: "16/9",
      background: "#f3f3f3",
      position: "relative",
    }}
  >
    <div
      style={{
        position: "absolute",
        bottom: "8px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        background: "rgba(0,0,0,0.2)",
      }}
    />
  </div>
);
